module.exports = __webpack_public_path__ + "img/gradient-blob.105874f2.svg";